import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize } from 'rxjs';
import { helper } from 'src/environments/helper';
import { CopiiService } from '../copii.service';
import { Copil } from '../copii.interface';

@Component({
    selector: 'app-add-copii',
    templateUrl: './add-copii.component.html',
    styleUrls: ['./add-copii.component.scss']
})
export class AddCopiiComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;

    form: FormGroup = new FormGroup({
        first_name: new FormControl('', Validators.required),
        last_name: new FormControl('', Validators.required),
        parintii: new FormControl('', Validators.required),
        birth_date: new FormControl('', Validators.required),
        cnp: new FormControl('', Validators.required),
        locatie: new FormControl('', Validators.required),
        email: new FormControl('', Validators.required),
        telefon: new FormControl('', Validators.required),
        status: new FormControl('', Validators.required),
        observatii: new FormControl(''),
    });

    constructor(
        private dialogRef: MatDialogRef<AddCopiiComponent>,
        private copiiService: CopiiService,
        private notificationService: NotificationService,
        private authService: AuthService,
    ) {
        this.processToken();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.copiiService.setToken(token);
        });
    }

    formatDate(date: Date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    submitForm() {
        this.isLoading = true;

        const { first_name, last_name, parintii, status, birth_date, cnp, locatie, email, telefon, observatii } = this.form.value as any;

        const newCopil: Copil = {
            first_name,
            last_name,
            parintii,
            status,
            birth_date: birth_date ? this.formatDate(birth_date) : '',
            cnp,
            locatie,
            email,
            telefon,
            observatii
        };

        this.copiiService
            .addCopil(newCopil)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let errorMessage =
                        environment.config.customNotifications.generalMessages.error;
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        errorMessage,
                        this.errorIcon
                    );
                },
            });
    }
}
